import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { actions as actionsHeader } from '../../redux/actions/site';
import './Modal.scss';

const ModalGeneric = props => {
  const dispatch = useDispatch();
  const modal = useSelector(state => state.site.modal);
  const [sendingData, setSendindData] = useState(modal.sendingData || false);

  const renderActions = () => {
    if(modal.actions){
      return modal.actions.map((action, index) => {
          return (
            <Button key={index} color={action.color} onClick={
              (e) => {
                e.stopPropagation();
                if (action.isSendingData) {
                  setSendindData(true);
                }
                if (action.callback){
                  action.callback(action.arg, action.afterCallback);
                }
                if (action.callbackProps){
                  action.callbackProps(action.arg);
                }
              }
            } disabled={sendingData}>
              {action.icon}
              {!action.icon && <i className="fas fa-check"></i>}
              {!sendingData && ` ${action.label}`}
              {sendingData && " Processando..."}
            </Button>
          )
      })
    }
  }

  const close = () => {
    if(modal.callbackCancel){
        modal.callbackCancel(modal.argCancel);
    } else {
        dispatch(actionsHeader.closeModal());
    }
  }

  return (
    <Modal isOpen={true} className={`modalGeneric ${modal.size ?? 'modal500' }`}>
      <ModalHeader>{modal.title}</ModalHeader>
      <ModalBody>
        <Col>
          <Card className="mb-1">
            {modal.msg &&
              <div className="msg">
                <span dangerouslySetInnerHTML={{ __html: modal.msg }}></span>
              </div>}
            {modal.component && modal.component}
          </Card>
        </Col>
      </ModalBody>
      <ModalFooter>
        {renderActions()}
        <Button color="secondary" onClick={close}>
          <i className="fas fa-times-circle"></i> Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalGeneric;
